import { InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from './../authConfig';

export async function getAccessTokenAsync(msalInstance: IPublicClientApplication, forceRefresh = false) {
    const account = msalInstance.getAllAccounts()[0];

    // Redirect to login
    if (!account) {
        await msalInstance.loginRedirect();
    }

    const tokenRequest = {
        ...loginRequest,
        account,
        forceRefresh,
    };

    try {
        // Attempt to get the token silently first
        const silentResult = await msalInstance.acquireTokenSilent(
            tokenRequest
        );
        return silentResult.accessToken;
    } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            // Because you’re already inside MsalAuthenticationTemplate,
            // this will trigger the redirect flow automatically
            await msalInstance.acquireTokenRedirect(tokenRequest);
            return Promise.reject('Redirect initiated for token');
        }
        throw err;
    }
}
